import { useState } from 'react';
import PropTypes from 'prop-types';

// material
import { styled } from '@material-ui/core/styles';
import { Box, Stack, Button, Popover, Container, Typography, IconButton } from '@material-ui/core';
// eslint-disable-next-line import/no-unresolved
// eslint-disable-next-line import/no-unresolved
import { Icon } from '@iconify/react';
import Page from '../Page';

//
// import { Block } from '../Block';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  paddingTop: theme.spacing(11),
  paddingBottom: theme.spacing(15)
}));

const style = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

// ----------------------------------------------------------------------

PopOverCustom.propType = {
  btnName: PropTypes.string,
  ComponentCalled: PropTypes.element,
  dialogTitle: PropTypes.string,
  showbtnIcon: PropTypes.bool,
  iconBtn: PropTypes.object,
  filterOptions: PropTypes.array
};
export default function PopOverCustom({ filterOptions, ComponentCalled, iconBtn, showbtnIcon = false, title }) {
  const [click, setCLick] = useState(null);
  // const [open, setOpen] = useState(false);
  const [hover, setHover] = useState(null);

  const handleClick = (event) => {
    setCLick(event.currentTarget);
  };

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  const handleClose = () => {
    setCLick(null);
  };

  // const handleHoverOpen = (event) => {
  //   setHover(event.currentTarget);
  // };

  // const handleHoverClose = () => {
  //   setHover(null);
  // };

  return (
    <RootStyle title={title}>
      {/* <Box
        sx={{
          pt: 6,
          pb: 1,
          mb: 10,
          bgcolor: (theme) => (theme.palette.mode === 'light' ? 'grey.200' : 'grey.800')
        }}
      >
        <Container maxWidth="lg">
          <HeaderBreadcrumbs
            heading="Popover"
            links={[{ name: 'Components', href: PATH_PAGE.components }, { name: 'Popover' }]}
            moreLink="https://next.material-ui.com/components/popover"
          />
        </Container>
      </Box> */}

      <Container maxWidth="lg">
        <Stack spacing={3} direction={{ xs: 'column', md: 'row' }}>
          {/* <Block title="Click" sx={style}> */}
          {showbtnIcon ? (
            <IconButton size="small" onClick={handleClick}>
              <Icon icon={iconBtn} />
            </IconButton>
          ) : (
            <Button variant="contained" onClick={handleClick}>
              Open Filters
            </Button>
          )}

          <Popover
            open={Boolean(click)}
            anchorEl={click}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center'
            }}
          >
            <Box sx={{ p: 1, width: '280px' }}>
              <Stack
                direction={{ xs: 'row', sm: 'row' }}
                spacing={{ xs: 2, sm: 2 }}
                sx={{ p: 1 }}
                justifyContent="space-evenly"
              >
                <Typography variant="subtitle1">Filters</Typography>
              </Stack>
              {/* <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                Fusce vulputate eleifend sapien. Curabitur at lacus ac velit ornare lobortis.
              </Typography> */}
              <ComponentCalled filterOptions={filterOptions} handleClose={handleClose} />
            </Box>
          </Popover>
          {/* </Block> */}
        </Stack>
      </Container>
    </RootStyle>
  );
}
